module.exports = __webpack_public_path__ + "img/notif_red.5df3af11.svg";